class Budget {
  constructor(budgetData = {}) {
    this.actualBudget =
      budgetData.actualBudget || budgetData.actual_budget || [];
    this.lastBudget = budgetData.lastBudget || budgetData.last_budget || [];
  }
}

export default Budget;
